var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-item"},[_c('h2',{staticClass:"heading"},[_vm._v("Start the Set Up Process Here")]),_c('p',{staticClass:"text"},[_vm._v("Click next.")])])
}]

export { render, staticRenderFns }